export default "__VITE_ASSET__wW_ol0ln__"